import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { Notification } from '../shared/models/notification.model';
import { ToastComponent } from '../shared/toast/toast.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  standalone: false
})
export class NotificationsComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);
  toast = inject(ToastComponent);
  private notificationService = inject(NotificationService);


  isLoading = true;
  currentContent = 'notifications';
  menuItems = [
    { name: 'Notifications', link: 'notifications', icon: 'bell' }
  ];
  notifications: Notification[];

  ngOnInit(): void {
    this.getNotifications();
  }

  getNotifications(): void {
    const params = {
      _user: this.auth.currentUser._id,
    };
    this.notificationService.search(params)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: res => this.notifications = res.results,
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

  goToLink(notification: Notification): void {
    this.markAsRead(notification);
    this.router.navigate([`/record/${notification._record._id}`]);
  }

  markAsRead(notification: Notification): void {
    this.notificationService.update({ _id: notification._id, read: true })
      .pipe(finalize(() => this.getNotifications()))
      .subscribe({
        next: res => true,
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead()
      .pipe(finalize(() => this.getNotifications()))
      .subscribe({
        next: res => this.toast.setMessage('All notifications marked as read', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
